import Image from "next/image";
import Link from "next/link";
import React from "react";
const RaceCalendarListView = ({
  races,
  isRaceCalendarAdmin
}) => {
  return <>
      <div className="grid grid-cols-1 gap-[1.875rem] sm:grid-cols-2 md:grid-cols-3">
        {races.map(race => <article key={race.id}>
            <div className="rounded-2xl overflow-hidden transition-shadow hover:shadow-lg">
              <Link href={`/apps/race-calendar/detail/${race.id}`}>
                <figure className="group overflow-hidden border-jacarta-100 rounded-t-[1.25rem] border border-b-0 bg-white" style={{
              minHeight: '220px',
              backgroundImage: `url(${race.imageUrl})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: 'contain'
            }}>
                </figure>
              </Link>

              {/* <!-- Body --> */}
              <div className="dark:border-jacarta-600 dark:bg-jacarta-700 border-jacarta-100 rounded-b-[1.25rem] border border-t-0 bg-white p-[10%]">
                {/* <!-- Meta --> */}
                <div className="mb-3 flex flex-wrap items-center space-x-1 text-xs">
                  <a href={`/apps/race-calendar/detail/${race.id}`} className="dark:text-jacarta-200 text-jacarta-700 font-display hover:text-accent">
                    {race.track}
                  </a>
                  <span className="dark:text-jacarta-400">on</span>
                  <span className="text-accent inline-flex flex-wrap items-center space-x-1">
                    {race.startDate}
                  </span>
                </div>

                <h2 className="font-display text-jacarta-700 dark:hover:text-accent hover:text-accent mb-4 text-xl dark:text-white">
                  <Link href={`/apps/race-calendar/detail/${race.id}`}>{race.title}</Link>
                </h2>

                <div className="mt-10 mb-10 text-center">
                    <Link href={`/apps/race-calendar/detail/${race.id}`} className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 dark:hover:bg-accent hover:bg-accent text-jacarta-700 mb-4 items-center justify-center rounded-full border-2 bg-white py-4 px-8 text-center font-semibold transition-all hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent">
                    View Details
                    </Link>
                </div>

                {isRaceCalendarAdmin && <div className="mt-10 mb-10 text-center">
                    <Link href={`/apps/race-calendar/edit/${race.id}`} className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 dark:hover:bg-accent hover:bg-accent text-jacarta-700 mb-4 items-center justify-center rounded-full border-2 bg-white py-4 px-8 text-center font-semibold transition-all hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent">
                      Modify
                    </Link>
                  </div>}

                <div className="text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm">
                  <span>
                    <time>Dates: {race.startDate}</time>
                  </span>
                  <span>•</span>
                  <span>{race.endDate}</span>
                </div>
              </div>
            </div>
          </article>)}
      </div>
    </>;
};
export default RaceCalendarListView;